/**
 * @summary - Component that Provides User Location Creation Page
 * @author Kanimozhi r
 * @since 2024-06-17
 */
import { Box, Grid } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { DefaultCard } from "../../assets/styled-components/card";
import { MasterGraph } from "../../utility/apiURLS";
import {
  getAuthToken,
  getCreatedBy,
  getFacilityId,
  getModifiedBy
} from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomFooter from "../commoncomponents/CustomFooter";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import PageTitle from "../commoncomponents/PageTitle";
import CustomAlert from "./CustomAlert";

const CreateUserLocation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [locationId, setLocationId] = useState("");
  const [locationcode, setLocationCode] = useState("");
  const [locationdesc, setLocationDesc] = useState("");
  const [departmentcode, setDepartmentCode] = useState("");
  const [departmentdesc, setDepartmentDesc] = useState("");
  const [departmentid, setDepartmentId] = useState("");
  const [effectivefromdate, setEffectiveFromDate] = useState("");
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [isAddNew, setIsAddNew] = useState(false);
  const statusOptions = [
    { value: "Active", label: "Active", id: true },
    { value: "Inactive", label: "Inactive", id: false },
  ];
  const defaultStatus = statusOptions.find(
    (option) => option.value === "Active"
  );
  const [status, setStatus] = useState(defaultStatus.value); // Default to 'Active'
  const [isEditMode, setIsEditMode] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const currentDate = utils.getCurrentDateFormatted("DD-MM-YYYY");
  const [duplicateErrorMessage, setDuplicateErrorMessage] = useState("");
  const [previousEffectiveFromDate, setPreviousEffectiveFromDate] =
    useState(null);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [dialogContent, setDialogContent] = useState('');
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  const locationDepartmentcode = location?.state?.departmentcode;

  const [errors, setErrors] = useState({
    service: false,
    wgcode: false,
    locationcode: false,
    locationdesc: false,
    departmentcode: false,
    departmentdesc: false,
    effectivefromdate: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    locationcode: "",
    locationdesc: "",
    departmentcode: "",
    departmentdesc: "",
    effectivefromdate: "",
  });

  const facilityid = getFacilityId("facilityId");
  const createdBy = getCreatedBy("createdBy");
  const modifiedBy = getModifiedBy("modifiedBy");

  function moveLabelToFirstIndex(array, valueToMove) {
    // Find the index of the object with the matching value
    const index = array.findIndex((obj) => obj.value === valueToMove);

    // If the object is found and is not already at the first index
    if (index > 0) {
      // Remove the object from its original position
      const [item] = array.splice(index, 1);

      // Insert the object at the first index
      array.unshift(item);
    }

    return array;
  }

  
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const token = getAuthToken("id_token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const departmentDetailsResponse = await axios.get(
          `${MasterGraph}/api/GraphUserDepartmentDetails/GetUserDepartmentDetailsByFacilityId/${facilityid}?size=1000`,
          config
        );

        const departmentOptions = departmentDetailsResponse.data.items.map(
          (department) => ({
            value: department.departmentcode,
            label: ` ${department.departmentdesc} - ${ department.departmentcode} `,
            id: department.id,
          })
        );

        setDepartmentOptions(departmentOptions);

        if (location?.state) {
          const {
            locationcode,
            locationdesc,
            serviceid,
            id,
            readOnly,
          locationeffectivedate,
            status,
            departmentcode,
            departmentdesc,
            mode,
            departmentid,
          } = location.state;

          setLocationCode(locationcode);
          setLocationDesc(locationdesc);
          setStatus(status);
          setEffectiveFromDate(locationeffectivedate);
          setDepartmentCode(departmentcode);
          const description = departmentOptions.find(
            (option) => option.label === departmentcode
          );
          setDepartmentDesc(
            description
                ? description
                : {
                    value: departmentdesc,
                    label: departmentdesc,
                    id: departmentid,
                }
        );

          const allDepartmentOptions = departmentOptions;
          const updatedArray = moveLabelToFirstIndex(
            departmentOptions,
            departmentcode
          );
          setDepartmentOptions(updatedArray);
         // setDepartmentDesc(description ? description : "");
          setLocationId(id);
          if (mode === "edit") {
           // setDepartmentDesc(description ? description : "");
           setDepartmentDesc(
            description
                ? description
                : {
                    value: departmentdesc,
                    label: departmentdesc,
                    id: departmentid,
                }
        );
            setIsEdit(true);
            setIsEditMode(true);
            setIsView(false);
            setReadOnly(readOnly); // Set readOnly to false when in edit mode
            setDepartmentId(description ? description.id : location.state.departmentid);
          } else if (mode === "view") {
            setIsView(true);
            setIsEdit(false);
            setReadOnly(readOnly); // Set readOnly to true when in view mode
            setIsEditMode(false);
          } else {
            setIsEdit(false);
            setIsView(false);
          }
        } else {
          setIsEdit(false);
        }
      } catch (error) {
       // console.error("Error fetching department details:", error);
      }
    };

    fetchDepartment();
  }, [location.state]);

  useEffect(() => {
    if (status === "Inactive") {
      setEffectiveFromDate(currentDate); // Setting specific date for Inactive status
    }
  }, [status]);

  useEffect(() => {
    if (status === "Inactive") {
      setPreviousEffectiveFromDate(effectivefromdate); // Store current effective date as previous
      setEffectiveFromDate(currentDate); // Set current date for Inactive status
    } else {
      if (previousEffectiveFromDate !== null) {
        setEffectiveFromDate(previousEffectiveFromDate); // Restore previous effective date for Active status
      }
    }
  }, [status]);

  const handleStatusChange = (newValue) => {
    setStatus(newValue.value); // Assuming newValue is an object { value: '...', label: '...' }
    setUnsavedChanges(true);
  };

  const handleEffectiveFromDateChange = (newValue) => {
    setEffectiveFromDate(newValue);
    setUnsavedChanges(true);

    if (newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, effectivefromdate: false }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        effectivefromdate: "",
      }));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
   // setUnsavedChanges(false);
    let formIsValid = true;
    const newErrors = {
      service: false,
      locationcode: false,
      locationdesc: false,
      departmentdesc: false,
    };
    const newErrorMessages = {
      service: "",
      wgcode: "",
      locationcode: "",
      locationdesc: "",
      departmentdesc: "",
    };
    // Check existing errors state for special cases

    if (errors.locationcode) {
      formIsValid = false;
      newErrors.locationcode = true;
      newErrorMessages.locationcode = errorMessages.locationcode;
    }
    if (errors.locationdesc) {
      formIsValid = false;
      newErrors.locationdesc = true;
      newErrorMessages.locationdesc = errorMessages.locationdesc;
    }

    if (!locationcode) {
      formIsValid = false;
      newErrors.locationcode = true;
      newErrorMessages.locationcode = "Location Code is required";
    }

    if (!locationdesc) {
      formIsValid = false;
      newErrors.locationdesc = true;
      newErrorMessages.locationdesc = "Location Name is required";
    }
    if (!departmentdesc.label) {
      formIsValid = false;
      newErrors.departmentdesc = true;
      newErrorMessages.departmentdesc = "Department Description is required";
    }

    function isValidDateFormat(dateString) {
      // Regular expression to match "dd/mm/yyyy" format
      const dateFormatRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      return dateFormatRegex.test(dateString);
    }


    if (!effectivefromdate) {
      formIsValid = false;
      newErrors.effectivefromdate = true;
      newErrorMessages.effectivefromdate = "Effective From is required";
    }
    setErrors(newErrors);
    setErrorMessages(newErrorMessages);
    if (formIsValid) {
      handleSave();
    }
  };

  const handleCancel = () => {
    if (!unsavedChanges || isView) {
      navigate(-1, { replace: true });
    } else {
      setIsNavigating(true); // Set to true for navigation
      setCancelDialogOpen(true);
      setDialogContent("Record(s) not Saved/Updated. Do you want to continue?");
    }
  };
  function convertDateFormat(dateString) {
    if (!dateString) {
      return ""; // Return empty string or handle as needed if dateString is undefined or null
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return ""; // Handle invalid date strings
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const handleSave = async () => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      setUnsavedChanges(false);

      // Determine the endpoint and HTTP method based on the mode (edit or create)
      let endpoint = `${MasterGraph}/api/masuserlocationdetails`; // Adjust BaseGraph to your base URL
      let method = "post";
      if (isEditMode) {
        endpoint = `${MasterGraph}/api/masuserlocationdetails/${locationId}`;
        method = "put";
      }

      let dateFormatted = null;

      // Check if effectivefromdate is defined and not null
      if (effectivefromdate) {
        // Split the effectivefromdate string by '/'
        const parts = effectivefromdate.split("/");
        if (parts.length === 3) {
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; // Month is zero-based in JavaScript Date
          const year = parseInt(parts[2], 10);

          // Create a Date object using the parsed values
          const dateObject = new Date(year, month, day);

          // Check if dateObject is a valid date
          if (!isNaN(dateObject.getTime())) {
            // Format the date to "YYYY-MM-DDTHH:mm:ss" format
            const formattedYear = dateObject.getFullYear();
            const formattedMonth = String(dateObject.getMonth() + 1).padStart(
              2,
              "0"
            );
            const formattedDay = String(dateObject.getDate()).padStart(2, "0");
            const hours = String(dateObject.getHours()).padStart(2, "0");
            const minutes = String(dateObject.getMinutes()).padStart(2, "0");
            const seconds = String(dateObject.getSeconds()).padStart(2, "0");

            dateFormatted = `${formattedYear}-${formattedMonth}-${formattedDay}T${hours}:${minutes}:${seconds}`;
          } else {
         //   console.error("Invalid date:", effectivefromdate);
            dateFormatted = null; // Se
            // Handle invalid date scenario
          }
        } else {
          // console.error(
          //   "effectivefromdate has an incorrect format:",
          //   effectivefromdate
          // );
          dateFormatted = null; // Se
          // Handle incorrect format scenario
        }
      } else {
       // console.error("effectivefromdate is undefined or null");
        dateFormatted = null; // Se
        // Handle undefined or null scenario
      }

    //  console.log("dateFormatted", dateFormatted);

      const postData = {
        facilityid, // Replace with actual field value
        locationcode,
        locationdesc,
     
        locationeffectivedate:
          status === "Active"
            ? dateFormatted
            : status === "Inactive"
              ? new Date().toISOString().split(".")[0]
              : null,
        isactive: status === "Active" ? true : false,
        masuserdepartmentdetails: {
          id: departmentid,
          departmentcode,
          departmentdesc: departmentdesc.label, // Assuming departmentdesc is an object with a label property
        },
      };
      const postDataForUpdate = {
        facilityid, // Replace with actual field value
        locationcode,
        locationdesc,
     
        locationeffectivedate:
          status === "Active"
            ? dateFormatted
            :'',
        isactive: status === "Active" ? true : false,
        masuserdepartmentdetailsId: departmentid || location.state.departmentId,
        id : locationId,  // Add the location ID for edit mode
        isdeleted : false, 
        // {
        //   id: departmentid,
        //   departmentcode,
        //   departmentdesc: departmentdesc.label, // Assuming departmentdesc is an object with a label property
        // },
      };
      if (isEditMode) {
        postData.modifiedby = modifiedBy; // Replace modifiedBy with the actual value
        postData.modifieddate = new Date().toISOString().split(".")[0]; // Current date-time in ISO format without milliseconds
        postData.isdeleted = false; // Assuming this is always false for edit mode
        postData.id = locationId; // Add the location ID for edit mode
        postData.masuserdepartmentdetails.facilityid = facilityid;
        postData.masuserdepartmentdetails.masuserlocationdetails = [];
        postData.masuserdepartmentdetails.modifiedby = modifiedBy;
        postData.masuserdepartmentdetails.modifieddate = new Date()
          .toISOString()
          .split(".")[0];
        postData.masuserdepartmentdetails.isdeleted = false;
        postData.masuserdepartmentdetails.id = departmentid || location.state.departmentId;
        if (status === "Active") {
          postData.locationeffectivedate = dateFormatted;
        }
      } else {
        postData.createdby = createdBy; // Replace createdBy with the actual value
      }
      // Send the HTTP request using axios
      const response = await axios({
        method,
        url: endpoint,
        data: location?.state?.mode=="edit"?postDataForUpdate:postData,
        headers: config.headers,
      });
    //  console.log("response", response);
      setDialogOpen(true);
    } catch (error) {
    //  console.error("Error saving user Location:", error);
      if (error.response && error.response.status === 400) {
        setDuplicateErrorMessage(
          <span>
            User Location Code Already Exists.
          </span>
        );
      } else {
        setDuplicateErrorMessage(
          "An error occurred while saving the user location. Please try again."
        );
      }
    }
  };

  const handlelocationCodeChange = (newValue) => {
    setUnsavedChanges(true); 
    setLocationCode(newValue);

    const errors = [];
    const startsWithSpaceRegex = /^ /;
    const invalidCharRegex = /[^a-zA-Z0-9 /-]/;

    if (startsWithSpaceRegex.test(newValue)) {
      errors.push("Space not allowed at the beginning.");
    } else if (invalidCharRegex.test(newValue)) {
      errors.push("Only /- and a-zA-Z0-9 are allowed.");
    }

    if (errors.length > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, locationcode: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        locationcode: errors.join(" "),
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, locationcode: false }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        locationcode: "",
      }));
    }
  };


  const handleLocationDescChange = (newValue) => {
    setUnsavedChanges(true); // Set unsaved changes to true
    setLocationDesc(newValue);

    const errors = [];
    const startsWithSpaceRegex = /^ /;
    const allowedCharactersRegex = /^[a-zA-Z0-9 ,!@#$%&*()_-]*$/;

    if (startsWithSpaceRegex.test(newValue)) {
      errors.push("Space not allowed at the beginning.");
    } else if (!allowedCharactersRegex.test(newValue)) {
      errors.push("Only a-zA-Z0-9 ,!@#$%&*()_- are allowed.");
    }

    if (errors.length > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, locationdesc: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        locationdesc: errors.join(" "),
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, locationdesc: false }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        locationdesc: "",
      }));
    }
  };

  const handleDepartmentDescChange = (newValue) => {
    if (newValue?.label != '') {
      setUnsavedChanges(true); // Set
    }
    setDepartmentDesc({ ...newValue, label: newValue.label.split('-')[0].trim() });
    setDepartmentId(newValue?.id || "");
    const selectedOption = departmentOptions?.find(
      (option) => option.label === newValue?.label
    );
    if (selectedOption) {
      setDepartmentCode(selectedOption?.value);
      setErrors((prevErrors) => ({ ...prevErrors, departmentcode: false }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        departmentcode: "",
      }));
    } else {
      setDepartmentCode("");
    }
    setErrors((prevErrors) => ({ ...prevErrors, departmentdesc: false }));
    setErrorMessages((prevMessages) => ({
      ...prevMessages,
      departmentdesc: "",
    }));
  };

  const handleDepartmentCodeChange = (newValue) => {
    //  setUnsavedChanges(false); // Set
    setDepartmentCode(newValue);
    if (newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, departmentcode: false }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        departmentcode: "",
      }));
    }
  };
  const handleAddNew = () => {
    if (unsavedChanges) {
      setIsNavigating(false); // Set to false for "Add New"
      setIsAddNew(true);
      setCancelDialogOpen(true);
      setDialogContent("Record(s) not Saved/Updated. Do you want to continue?");
    } else {
      handleAdd();
    }
  };
  const handleAdd = () => {
    setIsEditMode(false);
    setLocationCode("");
    setLocationDesc("");
    setDepartmentCode("");
    setDepartmentDesc({value: '', label: ''});
    setEffectiveFromDate(null);
    setStatus(defaultStatus.value);
    setErrors(false);
    setErrorMessages("");
    setIsEdit(false);
    setIsView(false);
  };


  const handleDialogClose = () => {
    // Close the cancel dialog
    setCancelDialogOpen(false);
  
    // Handle unsaved changes scenario
    if (unsavedChanges) {
      setDialogOpen(false);
    }
  
    // Determine whether to navigate back or proceed with "Add New" action
    if (isNavigating) {
      navigate(-1, { replace: true }); // Navigate back if canceling
    } else if (isAddNew) {
      handleAdd(); // Execute "Add New" logic if adding new
    }
  
    // Reset state variables
    setIsAddNew(false);
    setDialogOpen(false);
  };
  

  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };

  const handleConfirmCancel = () => {
    setCancelDialogOpen(false);
  
    if (isNavigating) {
      navigate(-1, { replace: true });
    } else if (isAddNew) {
      handleAdd();
    }
  };

  return (
    <>
      <PageTitle
        title="Create User Location"
        isEdit={isEdit}
        isView={isView}
        editTitle={"Edit User Location"}
        viewTitle={"View User Location"}
      />

      <DefaultCard sx={{ height: "100%" }}>
        <form onSubmit={handleSubmit} style={{ position: "relative" }}>
          <Box mb={2}>
            <Grid container spacing={4}>
              <Grid item xs={6} md={4}>
                {isEdit ? (
                  <CustomSelectInput
                    id="status"
                    label="Status"
                    value={
                      statusOptions.find((option) => option.value === status) ||
                      null
                    }
                    options={statusOptions}
                    onChange={handleStatusChange}
                    disabled={readOnly}
                    isMandatoryField={true}
                  />
                ) : (
                  <CustomTextField
                    label="Status"
                    id="status"
                    value={status}
                    isRefilByOtherField={true}
                  />
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <CustomTextField
                  label="Location Code"
                  id="user-location-code"
                  value={locationcode}
                  onChange={handlelocationCodeChange}
                  disabled={isView || isEditMode ? true : false}
                  isMandatoryField={true}
                  error={errors.locationcode}
                  errorMessage={errorMessages.locationcode}
                  maxlength={10}
                  autoFocus={!isView && !isEditMode}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <CustomTextField
                  label="Location Name"
                  id="location-name"
                  value={locationdesc}
                  onChange={handleLocationDescChange}
                  disabled={readOnly}
                  isMandatoryField={true}
                  error={errors.locationdesc}
                  errorMessage={errorMessages.locationdesc}
                  maxlength={255}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <CustomTextField
                  label="Department Code"
                  id="department-code"
                  value={departmentcode}
                  onChange={handleDepartmentCodeChange}
                  disabled={readOnly}
                  isRefilByOtherField={true}
                  placeholder={false}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <CustomTextFieldWithSearch
                  isMandatoryField={true}
                  label="Department Description"
                  id="department-description"
                  value={departmentdesc}
                  options={departmentOptions} // Pass the department options
                  onChange={handleDepartmentDescChange} // Handle change function
                  isDisable={readOnly}
                  error={errors.departmentdesc}
                  errorMessage={errorMessages.departmentdesc}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <CustomDatePicker
                  label="Effective From"
                  isStartDate={true}
                  disablePastDate={true}
                  id={"effective-from"}
                  isMandatoryField={true}
                  value={effectivefromdate}
                  onDateChange={handleEffectiveFromDateChange}
                  error={errors.effectivefromdate}
                  helperText={errorMessages.effectivefromdate}
                  maxDate={currentDate}
                  disabled={readOnly}
                  minimumDate={status === "Inactive" ? currentDate : null}
                />
              </Grid>
            </Grid>
          </Box>
        </form>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: { xs: "center", md: "end" },
          }}
        >
          <CustomFooter
            cancelClick={handleCancel}
            saveClick={handleSubmit}
            addClick={handleAddNew}
            readOnly={readOnly}
            buttonLabel={isEdit ? "Update" : "Save"}
            isEdit={isEdit}
            showAddButton={true}
          />
        </Box>
      </DefaultCard>

      <CustomAlert
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDialogClose}
        confirmBtn="Ok"
        content={
          isEdit ? (
            <>Data updated successfully.</>
          ) : (
            <>Data saved successfully.</>
          )
        }
      />

      <CustomAlert
        open={!!duplicateErrorMessage}
        onClose={() => setDuplicateErrorMessage("")}
        onConfirm={() => setDuplicateErrorMessage("")}
        content={duplicateErrorMessage}
        confirmBtn="Ok"
      />

      <CustomAlert
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        onConfirm={handleConfirmCancel}
        content={dialogContent}
        cancelBtn="No"
        confirmBtn="Yes"
      />
    </>
  );
};

export default CreateUserLocation;
